import { render, staticRenderFns } from "./DSFlagRu.vue?vue&type=template&id=38a4c22a&"
import script from "./DSFlagRu.vue?vue&type=script&lang=js&"
export * from "./DSFlagRu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports